import { render, staticRenderFns } from "./AffiliateAddress.vue?vue&type=template&id=be94b454"
import script from "./AffiliateAddress.vue?vue&type=script&lang=ts"
export * from "./AffiliateAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports